module.exports = __webpack_public_path__ + "img/grav.425128be.png";